// src/pages/settings/templates/forms/builderDrawer/formElementTypes.ts
//
// The builder's element vocabulary, in one place. Both the drag palette
// (Toolbox) and the per-field type selector (BuilderCanvas) read this — if they
// kept separate lists, a type could be draggable but not selectable, or vice
// versa. That is the same drift that produced the radio/checkbox inversion.
//
// Canonical type strings only; see ../../../../../components/forms/fieldTypes.

import { FormElement } from "../../../../../api/formApi";
import { DEFAULT_CHOICE_OPTIONS } from "../../../../../components/forms/fieldTypes";

export interface FormElementTypeDef {
	type: string;
	label: string;
	/** Seeded on drop; the same defaults a type-change seeds (see patchForTypeChange). */
	options?: string[];
}

const CHOICE_DEFAULTS = [...DEFAULT_CHOICE_OPTIONS];

export const FORM_ELEMENT_TYPES: FormElementTypeDef[] = [
	{ type: "heading", label: "Section Heading" },
	{ type: "paragraph", label: "Paragraph Text" },
	{ type: "text", label: "Text (Single line)" },
	{ type: "textarea", label: "Textarea (Multi-line)" },
	{ type: "number", label: "Number" },
	{ type: "email", label: "Email" },
	{ type: "phone", label: "Phone Number" },
	{ type: "single_select", label: "Single Select", options: CHOICE_DEFAULTS },
	{ type: "multi_select", label: "Multi Select", options: CHOICE_DEFAULTS },
	{ type: "select", label: "Dropdown (Single Select)", options: CHOICE_DEFAULTS },
	{ type: "multiselect", label: "Dropdown (Multi Select)", options: CHOICE_DEFAULTS },
	{ type: "date", label: "Date Picker" },
	{ type: "time", label: "Time Picker" },
	{ type: "datetime", label: "Date & Time Picker" },
	{ type: "file", label: "File Upload" },
	{ type: "signature", label: "Signature" },
];

/** Palette entries as draggable element seeds. */
export const paletteElements = (): Omit<FormElement, "id">[] =>
	FORM_ELEMENT_TYPES.map(({ type, label, options }) => ({
		type,
		label,
		...(options ? { options: [...options] } : {}),
	})) as Omit<FormElement, "id">[];

/** Options for the per-field type selector. */
export const typeSelectOptions = FORM_ELEMENT_TYPES.map(({ type, label }) => ({
	value: type,
	label,
}));
